import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewTestComp from "./Component/ViewTestComp"


const ViewTest =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewTestComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewTest